import React from "react";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Dialog, {
  DialogContent,
  DialogContentText,
  DialogActions
} from "material-ui/Dialog";
import { withStyles } from "material-ui/styles";

import ErrorMessage from "components/ErrorMessage";

import CTextField from "uis/CTextField";
import { isCustomerAdmin } from "utils/formatter";

const styles = () => ({
  container: {
    padding: 20,
    margin: "20px auto",
    width: 1100,
  },
  header: {
    display: "flex",
    margin: 0
  },
  main: {
    width: 500,
    margin: "50px auto 20px"
  },
  errorMessages: {
    marginBottom: 10
  },
  textField: {
    marginTop: 20
  },
  buttonDiv: {
    marginTop: 30,
    textAlign: "center"
  }
});

class PasswordReset extends React.Component {
  componentWillMount() {
    this.props.checkResetToken(this.props.match.params.reset_token);
  }

  render() {
    const {
      classes,
      isAuthed,
      password,
      passwordConfirmation,
      errors,
      isDialogOpen
    } = this.props;

    return (
      <Paper className={classes.container}>
        <h2 className={classes.header}>パスワードリセット</h2>

        <Dialog
          open={isDialogOpen}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              パスワード変更が完了しました。
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              raised
              onClick={() =>
                this.props.historyPush(isCustomerAdmin() ? "/" : "/login")
              }
            >
              ログイン画面へ戻る
            </Button>
          </DialogActions>
        </Dialog>

        {isAuthed && (
          <div className={classes.main}>
            <ErrorMessage messages={errors} className={classes.errorMessages} />

            <CTextField
              id="password"
              label="新しいパスワード"
              type="password"
              value={password}
              onChange={e => this.props.changeForm("password", e.target.value)}
              fullWidth
            />
            <br />

            <CTextField
              id="password-confirmation"
              label="新しいパスワードの確認"
              type="password"
              value={passwordConfirmation}
              onChange={e =>
                this.props.changeForm("passwordConfirmation", e.target.value)
              }
              margin="dense"
              className={classes.textField}
              fullWidth
            />
            <br />

            <div className={classes.buttonDiv}>
              <Button
                raised
                onClick={() =>
                  this.props.handleSubmit(password, passwordConfirmation)
                }
              >
                パスワードを変更
              </Button>
            </div>
          </div>
        )}
      </Paper>
    );
  }
}

export default withStyles(styles)(PasswordReset);



// WEBPACK FOOTER //
// ./src/components/PasswordReset.js